import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  h2: FelaCSS;
  pillsWrapper: FelaCSS;
  pill: FelaCSS;
}

const styles = (withTopBorder: boolean): IStyles => ({
  wrapper: {
    marginTop: '10px',
    marginBottom: '10px',
    borderTop: withTopBorder ? `1px solid ${colors.space40}` : 'none',
    textAlign: 'center',

    maxWidthMobile: {
      borderTopWidth: 0,
    },
  },

  h2: {
    marginTop: '40px',
    marginBottom: '56px',
    fontDefaultSemiBold: 42,

    maxWidthMobile: {
      fontDefaultSemiBold: 40,
    },
  },

  pillsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
    justifyContent: 'center',
  },

  pill: {
    border: `1px solid ${colors.space40}`,
    fontDefaultSemiBold: 16,
    lineHeight: '24px',
    color: colors.space75,
    paddingHorizontal: 4,
    backgroundColor: colors.white,
    cursor: 'pointer',

    ':hover': {
      backgroundColor: colors.blueCrush30,
    },
  },
});

export default styles;
